// src/pages/NotFoundPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
    return (
        <div className="flex items-center justify-center min-h-[60vh] bg-gray-50 p-10">
            <div className="text-center">
                <h1 className="text-9xl font-extrabold text-indigo-600">404</h1>
                <p className="text-2xl font-semibold text-gray-800 mb-4">Página Não Encontrada</p>
                <Link 
                    to="/" 
                    className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg hover:bg-indigo-700 transition duration-300 shadow-md"
                >
                    Voltar para a Página Inicial
                </Link>
            </div>
        </div>
    );
}

export default NotFoundPage;